import React from 'react';
import { FormattedMessage } from 'react-intl';
import Popup from 'src/components/Popup/Popup';
import ServiceDescription from 'src/components/ServiceDescription/ServiceDescription';
import { calculateGrossPrice, IService, IServiceDetails } from '../../../../../entities/service';
import Image from '../../../../Image/Image';
import globalMessages from 'src/services/globalMessages';
import FormattedPrice from '../FormattedPrice/FormattedPrice';
import { useState } from 'react';
import { CalendarItemSkeleton } from '../../CalendarSelect/CalendarItem/CalendarItem';

interface IServiceItemProps {
    service: IServiceDetails;
    selectService: (service: IService) => void;
    button: React.ReactElement;
    withLogoSpace: boolean;
    needsPayment?: boolean;
}

const ServiceItem: React.FC<IServiceItemProps> = ({ service, selectService, button, withLogoSpace, needsPayment }) => {

    const [isLongDescriptionShown, setIsLongDescriptionShown] = useState(false);

    const { PictureLink, Name, IsDurationVisible, DurationToUser, ShortDescription, Description, DisplayedPrice, DisplayedCurrency, Price, Currency, PaymentMethod, VatPercentage } = service;

    return (
        <div className="service-item" id={`service-${service.Id}`}>
            {PictureLink ?
                <Image
                    className="service-item__service-logo"
                    src={PictureLink}
                />
                : withLogoSpace && <div className="service-item__service-logo" />
            }
            <header className="service-item__header">
                <h3 className="service-item__name">{Name}</h3>
                <div className="service-item__details">
                    <span >
                        {IsDurationVisible &&
                            <span className="service-item__detail">
                                <FormattedMessage {...globalMessages.minute} values={{ n: DurationToUser }} />
                            </span>
                        }
                        {DisplayedPrice &&
                            <span className="service-item__detail">
                                <FormattedPrice value={DisplayedPrice} currency={DisplayedCurrency} />
                            </span>
                        }
                        {needsPayment &&
                            <span className="service-item__price">
                                <span className="service-item__online-payable">
                                    <FormattedMessage {...globalMessages.toBePaid} />
                                </span>
                                <span className="service-item__online-price">
                                    <FormattedPrice value={calculateGrossPrice({ Price, Currency, PaymentMethod, VatPercentage })} currency={Currency} />
                                </span>
                            </span>
                        }
                    </span>
                </div>
            </header>
            {button}
            {(ShortDescription || Description) &&
                <div className="service-item__description">
                    {ShortDescription &&
                        <p className="service-item__description-text p--light-text">
                            {ShortDescription}
                        </p>
                    }
                    {Description &&
                        <>
                            <button onClick={() => setIsLongDescriptionShown(true)} className="service-item__more-description link">
                                <FormattedMessage {...globalMessages.readMore} />
                            </button>
                            <Popup
                                visible={isLongDescriptionShown}
                                closePopup={() => setIsLongDescriptionShown(false)}
                                title={service.Name}>
                                <ServiceDescription
                                    service={service}
                                    startReservation={() => selectService(service)}
                                    needsPayment={needsPayment}
                                />
                            </Popup>
                        </>
                    }
                </div>
            }
        </div>
    );
}

export const ServiceItemSkeleton = CalendarItemSkeleton;

export default ServiceItem;
